import React, { useState } from 'react';
import ConfirmationModal from './ConfirmationModal';
import Notification from './Notification';
import ChangesSummary from './ChangesSummary';
import './SearchBar.css';

const SearchBar = ({ 
  searchTerm, 
  setSearchTerm, 
  hasChanges, 
  saveChanges, 
  undoChanges, 
  updating,
  tableLocked,
  editedData,
  error,
  products,
  refreshFromServer,
  loading
}) => {

  const [showSaveModal, setShowSaveModal] = useState(false);
  const [showUndoModal, setShowUndoModal] = useState(false);
  const [notification, setNotification] = useState(null);

  const handleUpdate = () => {
    setShowSaveModal(true);
  };

  const handleConfirmSave = async () => {
    setShowSaveModal(false);
    const result = await saveChanges();
    if (result && result.success) {
      setNotification({
        message: result.message || 'Alterações salvas com sucesso!',
        type: 'success',
        isVisible: true
      });
    } else if (result && !result.success) {
      setNotification({
        message: result.error || 'Falha ao salvar alterações. Tente novamente.',
        type: 'error',
        isVisible: true
      });
    }
  };

  const handleCancelSave = () => {
    setShowSaveModal(false);
  };

  const handleUndo = () => {
    setShowUndoModal(true);
  };

  const handleConfirmUndo = () => {
    setShowUndoModal(false);
    undoChanges();
  };

  const handleCancelUndo = () => {
    setShowUndoModal(false);
  };

  const closeNotification = () => {
    setNotification(null);
  };

  return (
    <div className="search-bar-container">
      <div className="search-input-container">
        <input
          type="text"
          id="product-search"
          name="product-search"
          placeholder="Buscar produtos..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
        <div className="search-icon">🔍</div>
      </div>
      
      <button 
        onClick={refreshFromServer}
        className="refresh-button"
        disabled={loading || updating || tableLocked || hasChanges}
        title="Atualizar dados do servidor"
      >
        {loading ? '⟳' : '🔄'}
      </button>
      
      {hasChanges && (
        <div className="action-buttons">
          <button 
            onClick={handleUpdate}
            className="update-button"
            disabled={updating || tableLocked}
          >
            {updating ? 'Salvando...' : 'Salvar'}
          </button>
          <button 
            onClick={handleUndo}
            className="undo-button"
            disabled={updating || tableLocked}
          >
            Desfazer
          </button>
        </div>
      )}
      
      {/* Error display */}
      {error && (
        <div style={{color: 'red', fontSize: '14px', marginTop: '10px', padding: '8px', backgroundColor: '#ffebee', borderRadius: '4px'}}>
          ⚠️ {error}
        </div>
      )}
      
      
      <ConfirmationModal
        isOpen={showSaveModal}
        onConfirm={handleConfirmSave}
        onCancel={handleCancelSave}
        title="Confirmar Salvamento"
        message="Tem certeza de que deseja salvar essas alterações? Esta ação não pode ser desfeita."
        confirmText="Salvar"
        cancelText="Cancelar"
      >
        <ChangesSummary editedData={editedData} products={products} />
      </ConfirmationModal>
      
      <ConfirmationModal
        isOpen={showUndoModal}
        onConfirm={handleConfirmUndo}
        onCancel={handleCancelUndo}
        title="Confirmar Desfazer"
        message="Tem certeza de que deseja desfazer todas as alterações? Isso reverterá para o último estado salvo."
        confirmText="Desfazer"
        cancelText="Cancelar"
      >
        <ChangesSummary editedData={editedData} products={products} />
      </ConfirmationModal>
      
      {/* Notification */}
      {notification && (
        <Notification
          message={notification.message}
          type={notification.type}
          isVisible={notification.isVisible}
          onClose={closeNotification}
        />
      )}
    </div>
  );
};

export default SearchBar;
